import React from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './pages/Home';
import Events from './pages/Events';
import EventDetail from './pages/EventDetail';

const App: React.FC = () => {
  return (
    <Router>
      <div style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
        <Navbar />
        <main style={{ flex: 1 }}>
          <Switch>
            <Route path="/" exact component={Home} />
            <Route path="/events" component={Events} />
            <Route path="/event/:id" component={EventDetail} />
          </Switch>
        </main>
        <Footer />
      </div>
    </Router>
  );
};

export default App;